import { render, staticRenderFns } from "./platbill-details.vue?vue&type=template&id=bee4768c&"
import script from "./platbill-details.vue?vue&type=script&lang=js&"
export * from "./platbill-details.vue?vue&type=script&lang=js&"
import style0 from "./platbill-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports